/* ============================================================
   CART DRAWER QUANTITY FIX - 2026-10-07 (Sarah)

   REPORTED BY BRITTANY, real iPhone, cart drawer:
   "When I adjusted the quantity in the cart, it duplicated the line
   item and also added the additional quantity."

   ---- THE CAUSE -------------------------------------------------
   gd-conv.js listens for BOTH of these on the drawer stepper:

     click  on [data-cd-qty]        -> changeLine(line, value +/- 1)
     change on [data-cd-qty-input]  -> changeLine(line, value)

   On iOS, tapping + while the number input has focus fires BLUR ->
   CHANGE first, then CLICK. That is TWO changeLine() calls, two
   POSTs to /cart/change.js, racing each other against a line index
   that the first call is in the middle of changing.

   And changeLine() has NO RE-ENTRY GUARD. setBusy(true) writes a
   data-busy attribute that nothing ever reads. By contrast the CART
   PAGE handler in gd.js has had a proper lock since it was written:
       if (form.getAttribute('data-submitting') === '1') return;
   The drawer never got the equivalent.

   ---- WHY IT SURFACED TODAY -------------------------------------
   This bug is PRE-EXISTING, not introduced by the cross-sell work.
   What changed is that rev 2 gave the stepper buttons a fill and
   borders. Before that they read as a blank white box, so nobody
   tapped them. Making a broken control visible is how a latent bug
   becomes a reported one.

   ---- THE FIX ---------------------------------------------------
   1. A module-level in-flight lock. While a quantity POST is
      running, further quantity events are dropped rather than
      queued: queuing them would replay a stale line index against
      a cart that has already moved.
   2. The click handler writes the new value into the input BEFORE
      the async call, so any change event that fires afterwards sees
      the value we already sent and is a no-op rather than a second
      instruction.

   Capture phase + stopImmediatePropagation is deliberate: this file
   loads AFTER gd-conv.js, and a bubble-phase listener would run
   second, after gd-conv.js had already fired. Capture runs first and
   can stop the original handler from seeing the event at all.

   Reverts by deleting this file and one line of theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var inFlight = false;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function refreshDrawer() {
    var host = document.getElementById('shopify-section-cart-drawer');
    if (!host) return Promise.resolve();
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var d = host.querySelector('[data-cart-drawer]');
        var wasOpen = d && d.classList.contains('on');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp.firstElementChild;
        if (!fresh) return;
        host.replaceWith(fresh);
        if (wasOpen) {
          var nd = drawer();
          if (nd) { nd.classList.add('on'); nd.setAttribute('aria-hidden', 'false'); }
        }
      })
      .catch(function () {});
  }

  function syncCount() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        });
      })
      .catch(function () {});
  }

  /* One quantity instruction at a time. A dropped tap is recoverable;
     a duplicated line item is a wrong order. */
  function setQty(line, qty) {
    if (inFlight) return;
    inFlight = true;
    var d = drawer();
    if (d) d.setAttribute('data-busy', '1');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { return Promise.all([refreshDrawer(), syncCount()]); })
      .then(function () {
        inFlight = false;
        var nd = drawer();
        if (nd) nd.setAttribute('data-busy', '0');
      })
      .catch(function () {
        inFlight = false;
        window.location.href = root + 'cart';
      });
  }

  /* CAPTURE phase so this runs BEFORE gd-conv.js's bubble listener and
     can stop it. Without stopImmediatePropagation both handlers run and
     the duplication survives the fix. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cd-qty]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var row = btn.closest('[data-cd-line]');
    var input = row && row.querySelector('[data-cd-qty-input]');
    if (!input) return;

    var v = parseInt(input.value, 10) || 0;
    v += btn.getAttribute('data-cd-qty') === 'up' ? 1 : -1;
    if (v < 0) v = 0;

    /* Write it back FIRST. A change event firing after this reads the
       value we already sent, so it becomes a no-op instead of a second
       instruction. This is the half of the bug that is not the lock. */
    input.value = v;

    setQty(parseInt(btn.getAttribute('data-line'), 10), v);
  }, true);

  /* Typing a quantity directly. Same lock, same capture reasoning. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cd-qty-input]');
    if (!input) return;

    e.stopImmediatePropagation();

    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    input.value = v;

    setQty(parseInt(input.getAttribute('data-line'), 10), v);
  }, true);

})();
